import React from "react";
import WomanWhite from "../assets/images/womanCTA.png";
import { Link } from "react-router-dom";

const ContactCTA = () => {
  return (
    <div className="mb-0">
      {/* Mobile Layout (column format) */}
      <div className="block md:hidden">
        {/* Woman image below on mobile - centered */}
        <div className="flex justify-center mt-4">
          <img src={WomanWhite} alt="VernPOS Representative" className="w-4/5 object-contain" />
        </div>
        <div className="bg-vern rounded-xl text-white p-6">
          {/* Text content */}
          <div className="mb-4">
            <h2 className="text-xl font-bold mb-2">The Future of Business Management is Here</h2>
            <p className="text-sm mb-4">Let us show you how VernPOS can streamline your operations and drive growth.</p>
            <Link to="/contact-us" className="bg-white text-vern font-semibold py-2 px-6 rounded-md inline-block hover:bg-gray-100 transition-colors">
              Contact Sales
            </Link>
          </div>
        </div>
      </div>

      {/* Desktop Layout (woman breaking out of red background) */}
      <div className="hidden md:block relative">
        <div
          className="absolute -top-2 right-0 h-full flex items-center justify-end"
          style={{
            width: "45%",
            pointerEvents: "none",
          }}
        >
          <img
            src={WomanWhite}
            alt="VernPOS Representative"
            className="object-contain"
            style={{
              position: "relative",
              top: "-16.5%", // Adjusted to push the woman even more out of the box
              height: "145%", // Increased height for a taller appearance
              maxWidth: "130%", // Optionally make it slightly wider
            }}
          />
        </div>
        {/* Red background taking full width */}
        <div
          className="bg-vern rounded-xl text-white p-8"
          style={{
            marginTop: "150px",
            minHeight: "180px",
            paddingRight: "40%", // Create space for the woman image
          }}
        >
          <div className="max-w-lg">
            <h2 className="text-2xl font-bold mb-2">The Future of Business Management is Here</h2>
            <p className="mb-4">Let us show you how VernPOS can streamline your operations and drive growth.</p>
            <Link
              to="/contact-us"
              className="bg-white text-vern font-semibold py-2 px-6 rounded-full hover:bg-gray-100 transition-colors inline-block"
            >
              Contact Sales
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;
